import React from 'react';

import { graphql } from 'react-apollo';
import moment from 'moment';
import { Input, Select, Tooltip, Button, DatePicker } from 'antd/lib';
import { Form } from '@ant-design/compatible';
import * as Icons from '@ant-design/icons';

import _ from 'lodash';
import getTipoAtenciones from '../../../graphql/querys/tramites/getTipoAtenciones.graphql';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;

@graphql(getTipoAtenciones)
class FormAtencion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
      id_TipoAtencion: '',
      cantidad: 0,
      existeVenta: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log("Received values of form: ", values);
        // console.log(this.props);
        this.props.onSubmit({
          id_TipoAtencion: this.state.id_TipoAtencion,
          fecha: values.fecha,
          observacion: values.observacion,
        });
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  onChange(value) {
    this.setState({
      ...this.state,
      cantidad: value,
    });
  }

  crearOpciones(tipoAtencion) {
    return (
      <Option key={tipoAtencion._id} value={tipoAtencion._id}>
        {tipoAtencion.nombre}
      </Option>
    );
  }

  handleChange = id_tipoAtencion => {
    // console.log("Selecciono... ", id_tipoAtencion);

    this.setState({
      ...this.state,
      id_TipoAtencion: id_tipoAtencion,
    });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  onChangeCheckbox(e) {
    // console.log(`checked = ${e.target.checked}`);
    this.setState({
      ...this.state,
      existeVenta: e.target.checked,
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    let listaTiposAtenciones = this.props.data.getTipoAtenciones;
    if (listaTiposAtenciones) {
      var opciones = _.map(listaTiposAtenciones, this.crearOpciones);
    }

    return (
      <div>
        <h1 className="tituloForm">Datos de la Atencion</h1>

        <Form
          onSubmit={this.handleSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Tipo Atencion
                <Tooltip title="Seleccione el tipo de atencion que esta realizando">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('id_TipoAtencion', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, seleccione el tipo de atencion',
                },
              ],
            })(
              <Select
                showSearch
                style={{ width: 400 }}
                placeholder="Seleccione un tipo de atencion"
                optionFilterProp="children"
                onChange={this.handleChange}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {opciones}
              </Select>
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Fecha de la Atencion
                <Tooltip title="La fecha que ocurrio la atencion">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('fecha', {
              rules: [
                {
                  type: 'object',
                  required: true,
                  message: 'Por favor, seleccione la fecha de la atencion',
                },
              ],
            })(
              <DatePicker
                style={{ width: 400 }}
                placeholder="Fecha de la atencion"
                format="DD/MM/YYYY"
              />
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Observación
                <Tooltip title="Si lo desea, puede agregar algun comentario del envio">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('observacion', {})(
              <TextArea style={{ width: 400 }} rows={4} />
            )}
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Generar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    return {
      id_TipoAtencion: Form.createFormField({
        value: props.datos ? props.datos.id_tipoAtencion : '',
      }),
      fecha: Form.createFormField({
        value:
          props.datos && props.datos.fecha
            ? moment(new Date(props.datos.fecha), 'DD/MM/YYYY')
            : moment(),
      }),
      observacion: Form.createFormField({
        value: props.datos ? props.datos.observacion : '',
      }),
    };
  },
})(FormAtencion);
